module.exports = __webpack_public_path__ + "assets/images/pages/fundivisa/icon-fundivisa-1.png?fe60c9f7";